import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import axiosClient from '../../libs/axiosClient';
import HeaderMain from "../../components/HeaderMain/HeaderMain";
import HeaderMobile from "../../components/HeaderMobile/HeaderMobile";
import Footer from "../../components/Footer/Footer";
import successIcon from "../../assets/successIcon.png";
import styles from "./OrderSuccess.module.scss"

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);
  const [response, setResponse] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  const [selectedTab, setSelectedTab] = useState("consultation");
  const [isLoading, setIsLoading] = useState(true);
  const { t, i18n } = useTranslation();

  const paymentKey = searchParams.get('paymentKey');
  const orderId = searchParams.get('orderId');
  const amount = searchParams.get('amount');
  
  useEffect(() => {
    const savedLanguage = localStorage.getItem("selectedLanguage") || "en";
    if (i18n.language !== savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };

  }, [i18n]);

  useEffect(() => {
    const confirmPayment = async () => {
      try {
        const res = await axiosClient.post(
          '/api/v1/payment/confirm',
          {
            paymentKey,
            orderId,
            amount: amount,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
              'Content-Type': 'application/json',
            },
          }
        );

        setResponse(res.data);
      } catch (err: any) {
        console.error('결제 승인 실패:', err);
        setError(err.response?.data?.message || '결제 승인에 실패했습니다.');
        navigate('/order');
      } finally {
        setIsLoading(false);
      }
    };

    if (paymentKey && orderId && amount) {
      confirmPayment();
    }
  }, [paymentKey, orderId, amount, navigate]);

  return (
    <>
      {isMobile ? (
        <HeaderMobile />
      ) : (
        <HeaderMain selectedTab={selectedTab} onTabChange={setSelectedTab} />
      )}
      <div className={styles.successContainer}>
        <img src={successIcon} className={styles.successIcon} />
        <h1 className={styles.title}>{t('orderSuccess.completed')}</h1>
        <p className={styles.subtitle}>{t('orderSuccess.completedText')}</p>
        {isLoading ? (
          <div className={styles.loadingContainer}>
            <div className={styles.spinner}></div>
            <p className={styles.loadingText}>{t('orderSuccess.loading')}</p>
          </div>
        ) : (
          response && (
            <div className={styles.details}>
              <div className={styles.detailsRow}>
                <span className={styles.label}>{t('orderSuccess.totalAmount')}</span>
                <span className={styles.value}><span>${response.totalAmount.toLocaleString()}</span></span>
              </div>
              <div className={styles.detailsRow}>
                <span className={styles.label}>{t('orderSuccess.productPrice')}</span>
                <span className={styles.value}>${response.suppliedAmount.toLocaleString()}</span>
              </div>
              <div className={styles.detailsRow}>
                <span className={styles.label}>{t('orderSuccess.vat')}</span>
                <span className={styles.value}>${response.vat.toLocaleString()}</span>
              </div>
            </div>
          )
        )}
        <button 
          className={styles.confirmButton}
          onClick={() => navigate("/")}
        >
          {t('orderSuccess.home')}
        </button>
      </div>
      <Footer />
    </>
  );
};

export default PaymentSuccess;
